<template>
  <div class="rec-feeds">
    <div class="rec-container">
      <div class="title">
        {{ title }}
      </div>
      <ul class="list">
        <RecItem
          v-for="(feed, index) in recFeeds"
          :key="feed.id"
          :feed="feed"
          @on-click-feed="(feed: typeof recFeeds[0], clickMiniApp: boolean) => onClickFeed(feed, index, clickMiniApp)"
        />
      </ul>
      <div class="swipper-for-bottom">
        <div
          class="btn-jump-weishi"
          @click="openApp(true, false)"
        >
          去微视看更多精彩视频
          <JumpMiniApp
            v-if="miniAppPathClickMore"
            :path="miniAppPathClickMore"
            @launch="openApp(false, true, true)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs, ref, computed, inject, onMounted } from 'vue';
import { useStore } from '@/store/index';
import fetchZzConfig from '@/services/fetch-zz-config';
import { ModelMetaFeed } from '@/types/model';
import { ZzConfig } from '@/types/services/fetch-zz-config';
import { EMiniAppPosition } from '@/constants/mini-app';
import { PROVIDED_URL_INFO_NAME, TUrlInfo } from '@/composable/use-provide-url-info';
import useGetCommonMethods from '@/composable/use-get-common-method';
import { userRecFeedsReport } from '@/composable/use-compoent-report-methods';
import JumpMiniApp from '@/components/common/jump-mini-app.vue';
import RecItem from './item.vue';

// props
interface Props {
  showRec: boolean,
  recFeeds: ModelMetaFeed[],
}
const props = withDefaults(defineProps<Props>(), {
  showRec: false,
  recFeeds: () => ([]),
});
const {
  showRec,
  recFeeds,
} = toRefs(props);

// data
const zzConfig = ref<null | ZzConfig>(null);

// setup
const urlInfo = inject<TUrlInfo>(PROVIDED_URL_INFO_NAME);
const {
  getMiniAppPath,
  openSchemaCheckInstallInQQAppendParams,
  openSchemaAppendParamsClipboard,
} = useGetCommonMethods();
const recFeedsReport = userRecFeedsReport({ zzConfig, recFeeds, showRec });

// state
const { state } = useStore();
const isCollection = computed(() => state.isCollection);

// computed
const miniAppPathClickMore = computed(() => getMiniAppPath(EMiniAppPosition.jumpWeishi, { outFrom: 10001 }));
const configRecPage = computed(() => zzConfig.value?.recPage || { defaultLabelImg: '', videoTagReportMap: [], recTitle: '', recMaxNum: 20 });
const title = computed(() => configRecPage.value?.recTitle || '热门推荐');

// methods
const onClickFeed = (feed: ModelMetaFeed, index: number, clickMiniApp: boolean) => {
  if (!clickMiniApp) {
    openSchemaCheckInstallInQQAppendParams(true, isCollection.value, 'feed', {
      feed_id: feed.id,
    });
  }
  recFeedsReport.onClickFeed(feed, index);
};
const openApp = (jump: boolean, canDownload: boolean, clickMiniApp?: boolean) => {
  const { id: feedId } = urlInfo?.query || {};
  if (!clickMiniApp) {
    if (canDownload) {
      openSchemaAppendParamsClipboard(true, 'feed', {
        feed_id: feedId,
      });
    } else {
      openSchemaCheckInstallInQQAppendParams(true, isCollection.value, 'feed', {
        feed_id: feedId,
      });
    }
  }
  recFeedsReport.openApp(jump);
};

onMounted(async () => {
  // 初始化zzConfig
  zzConfig.value = (await fetchZzConfig({
    key: 1754,  // 配置中心key
    flag: 1,    // 配置中心的标识
  }));

  // 初始化灯塔上报
  recFeedsReport.init();
});
</script>

<style lang="scss" scoped>
.rec-feeds {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 20;
  background: rgba(0, 0, 0, 0.9);

  .rec-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .title {
    @include responsiveStyleSingle(margin-bottom, 4.2667, 'vw');
    @include responsiveStyleSingle(margin-left, 3.4667, 'vw');
    @include responsiveStyleSingle(font-size, 4.8, 'vw');
    font-weight: bold;
  }
  .list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    @include responsiveStyleSingle(padding-left, 3.4667,'vw');
    @include responsiveStyleSingle(padding-right, 3.4667,'vw');
  }
  .btn-jump-weishi {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    @include responsiveStyleSingle(margin-top, 5, 'vw');
    margin-left: auto;
    margin-right: auto;
    @include responsiveStyleSingle(width, 60, 'vw');
    @include responsiveStyleSingle(height, 11, 'vw');
    background: #7a46ff;
    @include responsiveStyleSingle(border-radius, 5.8667, 'vw');
    @include responsiveStyleSingle(font-size, 4.2, 'vw');
  }
  .swipper-for-bottom {
    @include responsiveStyleSingle(width, 100, 'vw');
  }
}
</style>
